import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';
import { Icon } from './Icon';

type ToastKind = 'ok' | 'err';
interface ToastItem { id: string; msg: string; kind: ToastKind }
type Push = (msg: string, kind?: ToastKind) => void;

const ToastCtx = createContext<Push | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<ToastItem[]>([]);
  const push = useCallback<Push>((msg, kind = 'ok') => {
    const id = Math.random().toString(36).slice(2);
    setToasts((t) => [...t, { id, msg, kind }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 3200);
  }, []);

  return (
    <ToastCtx.Provider value={push}>
      {children}
      <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1000, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {toasts.map((t) => (
          <div
            key={t.id}
            style={{
              background: t.kind === 'ok' ? '#15534d' : '#a3331f',
              color: '#fff',
              padding: '10px 16px',
              borderRadius: 10,
              boxShadow: '0 10px 30px -10px rgba(0,0,0,0.3)',
              fontSize: 13,
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              animation: 'pop 0.18s',
            }}
          >
            <Icon name={t.kind === 'ok' ? 'check' : 'alert'} size={16} />
            {t.msg}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export function useToast(): Push {
  const ctx = useContext(ToastCtx);
  if (!ctx) throw new Error('useToast must be inside <ToastProvider>');
  return ctx;
}
